module.exports = __webpack_public_path__ + "competition-9d743c92.webp";